export default __webpack_public_path__ + "static/media/c-introduce-item-img-02.867ba601.png";